export const quantityButtonStyles = {
    height: '32px',
    width: '32px',
    minWidth: '32px',
    padding: '0',
    boxSizing: 'border-box',
    color: '#626262',
    backgroundColor: '#F4F4F4',
    border: '1px solid #DFDFDF',
    '&:hover, &:focus-visible': {
        backgroundColor: '#DFDFDF',
    },
    '&:disabled': {
        color: '#D3D3D3',
        backgroundColor: '#F4F4F4',
    },
};

export const leftButtonStyles = {
    ...quantityButtonStyles,
    borderRadius: '4px 0 0 4px',
    borderRight: 'none',
};

export const rightButtonStyles = {
    ...quantityButtonStyles,
    borderRadius: '0 4px 4px 0',
    borderLeft: 'none',
};

export const errorColor = '#E53935';
export const errorDisabledColor = '#FECDD2';

export const errorButtonStyles = {
    color: errorColor,
    backgroundColor: '#FEEBED',
    borderColor: '#FEEBED',
    '&:hover, &:focus-visible': {
        backgroundColor: '#F8DDE1',
    },
    '&.Mui-disabled': {
        color: errorDisabledColor,
        backgroundColor: '#FEEBED',
    },
};
